// router.js
import {createRouter, RouteRecordRaw} from 'vue-router';
import Info from '@/views/Info/index.vue';
import InfoSelect from '@/views/InfoSelect/index.vue';
import Detail from '@/views/Detail/index.vue';
// import OutLink from '@/views/OutLink/index.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/info', // 品类 id
    name: 'info',
    component: Info,
  },
  {
    path: '/info-select', // informationId
    name: 'info-select',
    component: InfoSelect,
  },
  {
    path: '/detail/:infoId', // informationId
    name: 'detail',
    component: Detail,
  },
  {
    path: '/outlink',
    name: 'outlink',
    component: () => import(

      /* webpackChunkName: "outLink" */
      '@/views/OutLink/index.vue'
    ),
  }
];

export default function (history: any) {
  return createRouter({
    history,
    routes
  });
}
